import { ISetStartEndOfAll } from '../interfaces/ISetStartEndOfAll';

export default class SetStartEndOfAll implements ISetStartEndOfAll
{
  startTime: string;
  endTime: string;
  weekDays: number;
}
